module.exports = __webpack_public_path__ + "img/feliz.0a340cfa.png";